import React from 'react';

interface IconProps {
    isActive: boolean;
}

export const UserIcon = ({ isActive }: IconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
            <path
                fill="#fff"
                d="M8.997 0a4.964 4.964 0 0 1 4.95 4.95 4.965 4.965 0 0 1-4.95 4.95 4.965 4.965 0 0 1-4.95-4.95A4.964 4.964 0 0 1 8.997 0ZM9 11.25c.675 0 1.327-.113 1.957-.315 1.98-.653 4.163-.113 5.49 1.485A6.933 6.933 0 0 1 18 16.785c0 .922-.742 1.665-1.665 1.665H1.665A1.661 1.661 0 0 1 0 16.785c0-1.643.585-3.173 1.552-4.365 1.305-1.598 3.51-2.138 5.49-1.485.63.202 1.283.315 1.958.315Z"
                fillOpacity={isActive ? 1 : 0.7}
            />
        </svg>
    );
};

export const HomeIcon = ({ isActive }: IconProps) => {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 20">
            <path
                d="M.5 19.285h5.429a.5.5 0 0 0 .5-.5v-3.357c0-.643 0-2.572 2.571-2.572s2.571 1.929 2.571 2.572v3.357a.5.5 0 0 0 .5.5H17.5a.5.5 0 0 0 .5-.5V8.633a2 2 0 0 0-.698-1.518L9.65.557a1 1 0 0 0-1.302 0L.7 7.115A2 2 0 0 0 0 8.633v10.152a.5.5 0 0 0 .5.5Z"
                fill="#fff"
                fillOpacity={isActive ? 1 : 0.7}
            />
        </svg>
    );
};

export const WalletIcon = () => {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12">
            <path
                d="M13.89 0H2.11C1.55 0 1.013.23.618.641A2.23 2.23 0 0 0 0 2.189V9.81c0 .58.222 1.137.618 1.548.395.41.932.641 1.492.641h11.78c.56 0 1.096-.23 1.492-.641.396-.41.618-.967.618-1.548V2.19c0-.58-.222-1.138-.618-1.548A2.071 2.071 0 0 0 13.89 0Zm.72 4.565h-4.244a.7.7 0 0 0-.426.15.744.744 0 0 0-.256.384c-.108.376-.33.706-.634.94-.304.235-.672.361-1.05.361s-.746-.126-1.05-.36a1.825 1.825 0 0 1-.634-.94.744.744 0 0 0-.256-.385.7.7 0 0 0-.426-.15H1.39v-1.98c0-.303.116-.594.323-.808.206-.214.486-.335.778-.335H13.51c.292 0 .572.12.779.335.207.214.322.505.322.808v1.98Z"
                fill="#fff"
            />
        </svg>
    );
};

export const OverflowMenuIcon = () => {
    return (
        <svg viewBox="0 0 17 5" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.422 2.297a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-8 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
                fill="#fff"
            />
        </svg>
    );
};

export const GiftIcon = ({ isActive }: IconProps) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.125 15.25C2.125 15.913 2.38839 16.5489 2.85723 17.0177C3.32607 17.4866 3.96196 17.75 4.625 17.75H8.21875C8.26019 17.75 8.29993 17.7335 8.32924 17.7042C8.35854 17.6749 8.375 17.6351 8.375 17.5937V10.4062C8.375 10.3648 8.35854 10.325 8.32924 10.2957C8.29993 10.2664 8.26019 10.25 8.21875 10.25H2.4375C2.35462 10.25 2.27513 10.2829 2.21653 10.3415C2.15792 10.4001 2.125 10.4796 2.125 10.5625V15.25ZM8.375 8.84371V4.62496H9.625V8.84371C9.625 8.88515 9.64146 8.92489 9.67076 8.95419C9.70007 8.98349 9.73981 8.99996 9.78125 8.99996H15.25C15.4629 8.99995 15.6743 8.96362 15.875 8.89253C16.2402 8.76286 16.5564 8.52337 16.7802 8.20692C17.004 7.89047 17.1244 7.51254 17.125 7.12496V6.49996C17.125 6.00268 16.9275 5.52576 16.5758 5.17413C16.2242 4.8225 15.7473 4.62496 15.25 4.62496H13.6664C13.6528 4.62474 13.6395 4.62097 13.6278 4.61403C13.6161 4.60708 13.6064 4.5972 13.5997 4.58536C13.593 4.57352 13.5895 4.56013 13.5895 4.54652C13.5896 4.53291 13.5932 4.51955 13.6 4.50777C13.9617 3.89718 14.0791 3.17244 13.9288 2.47887C13.7785 1.78531 13.3716 1.17419 12.7897 0.768066C12.2077 0.361939 11.4937 0.190824 10.7909 0.289034C10.0881 0.387243 9.44834 0.747516 9 1.29761C8.55166 0.747516 7.91193 0.387243 7.2091 0.289034C6.50627 0.190824 5.79229 0.361939 5.21033 0.768066C4.62837 1.17419 4.22145 1.78531 4.07117 2.47887C3.92088 3.17244 4.03835 3.89718 4.4 4.50777C4.40681 4.51955 4.41042 4.53291 4.41047 4.54652C4.41053 4.56013 4.40703 4.57352 4.40032 4.58536C4.39361 4.5972 4.38392 4.60708 4.37222 4.61403C4.36052 4.62097 4.3472 4.62474 4.33359 4.62496H2.75C2.25272 4.62496 1.77581 4.8225 1.42417 5.17413C1.07254 5.52576 0.875 6.00268 0.875 6.49996V7.12496C0.875552 7.51254 0.995978 7.89047 1.21977 8.20692C1.44356 8.52337 1.75975 8.76286 2.125 8.89253C2.32571 8.96362 2.53707 8.99995 2.75 8.99996H8.21875C8.26019 8.99996 8.29993 8.98349 8.32924 8.95419C8.35854 8.92489 8.375 8.88515 8.375 8.84371ZM9.625 3.06246C9.625 2.75342 9.71664 2.45133 9.88833 2.19438C10.06 1.93742 10.304 1.73716 10.5896 1.61889C10.8751 1.50063 11.1892 1.46969 11.4923 1.52998C11.7954 1.59027 12.0738 1.73908 12.2924 1.9576C12.5109 2.17612 12.6597 2.45453 12.72 2.75763C12.7803 3.06072 12.7493 3.37489 12.6311 3.6604C12.5128 3.94591 12.3125 4.18994 12.0556 4.36163C11.7986 4.53332 11.4965 4.62496 11.1875 4.62496H9.625V3.06246ZM6.70078 1.50386C6.91484 1.48852 7.12977 1.51743 7.33216 1.58881C7.53456 1.66019 7.72008 1.77249 7.87716 1.91872C8.03424 2.06495 8.15951 2.24198 8.24516 2.43875C8.33081 2.63553 8.37501 2.84784 8.375 3.06246V4.62496H6.8125C6.40847 4.62392 6.02055 4.46642 5.73016 4.18551C5.43976 3.9046 5.26946 3.52213 5.25501 3.11836C5.24056 2.71459 5.38307 2.32092 5.65263 2.01997C5.9222 1.71901 6.29786 1.53418 6.70078 1.50425V1.50386ZM9.78125 17.75H13.375C14.038 17.75 14.6739 17.4866 15.1428 17.0177C15.6116 16.5489 15.875 15.913 15.875 15.25V10.5625C15.875 10.4796 15.8421 10.4001 15.7835 10.3415C15.7249 10.2829 15.6454 10.25 15.5625 10.25H9.78125C9.73981 10.25 9.70007 10.2664 9.67076 10.2957C9.64146 10.325 9.625 10.3648 9.625 10.4062V17.5937C9.625 17.6351 9.64146 17.6749 9.67076 17.7042C9.70007 17.7335 9.73981 17.75 9.78125 17.75Z"
                fill="white"
                fillOpacity={isActive ? 1 : 0.7}
            />
        </svg>
    );
};

export const CryptoIcon = () => {
    return (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.963 8.236c.292-1.891-1.19-2.908-3.218-3.586l.658-2.562-1.606-.389-.64 2.495A68.94 68.94 0 0 0 9.87 3.9l.645-2.511L8.91 1l-.658 2.561c-.35-.077-.692-.153-1.025-.234l.002-.008-2.214-.537-.428 1.666s1.192.265 1.167.281c.65.158.767.576.748.907l-.75 2.92c.045.01.104.026.168.051l-.17-.04-1.05 4.088c-.08.192-.281.48-.736.37.016.023-1.167-.282-1.167-.282L2 14.528l2.09.506c.388.094.77.193 1.144.287l-.664 2.591 1.603.389.658-2.564c.439.115.864.222 1.28.322l-.656 2.552L9.061 19l.664-2.587c2.738.504 4.797.3 5.664-2.105.698-1.936-.035-3.053-1.476-3.782 1.05-.235 1.84-.905 2.05-2.29Zm-3.668 4.997c-.496 1.937-3.853.89-4.942.627l.882-3.433c1.088.264 4.579.786 4.06 2.806Zm.496-5.025c-.452 1.762-3.246.867-4.153.648l.8-3.114c.906.22 3.825.629 3.353 2.466Z"
                fill="#fff"
            />
        </svg>
    );
};

export const SparklesIcon = ({ isActive }: IconProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '30px', height: '30px' }}
        >
            <path
                d="M12 8C12 11.3137 9.31371 14 6 14C9.31371 14 12 16.6863 12 20C12 16.6863 14.6863 14 18 14C14.6863 14 12 11.3137 12 8Z"
                fill="white"
                fillOpacity={isActive ? 1 : 0.7}
            />
            <path
                d="M17 2C17 4.20914 15.2091 6 13 6C15.2091 6 17 7.79086 17 10C17 7.79086 18.7909 6 21 6C18.7909 6 17 4.20914 17 2Z"
                fill="white"
                fillOpacity={isActive ? 1 : 0.7}
            />
            <path
                d="M5.5 17C5.5 18.3807 4.38071 19.5 3 19.5C4.38071 19.5 5.5 20.6193 5.5 22C5.5 20.6193 6.61929 19.5 8 19.5C6.61929 19.5 5.5 18.3807 5.5 17Z"
                fill="white"
                fillOpacity={isActive ? 1 : 0.7}
            />
        </svg>
    );
};

export const SearchIcon = ({ isActive }: IconProps) => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: '30px', height: '30px' }}
        >
            <g opacity={isActive ? 1 : 0.5}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1533 6.62782C9.04043 6.62782 7.32764 8.34062 7.32764 10.4535C7.32764 12.5663 9.04043 14.2791 11.1533 14.2791C13.2661 14.2791 14.9789 12.5663 14.9789 10.4535C14.9789 8.34062 13.2661 6.62782 11.1533 6.62782ZM5.69971 10.4535C5.69971 7.44154 8.14135 4.99989 11.1533 4.99989C14.1652 4.99989 16.6068 7.44154 16.6068 10.4535C16.6068 13.4654 14.1652 15.907 11.1533 15.907C8.14135 15.907 5.69971 13.4654 5.69971 10.4535Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.9906 15.2908C16.3085 14.9729 16.8238 14.9729 17.1417 15.2908L19.4615 17.6106C19.7794 17.9284 19.7794 18.4438 19.4615 18.7617C19.1437 19.0796 18.6283 19.0796 18.3104 18.7617L15.9906 16.4419C15.6727 16.124 15.6727 15.6086 15.9906 15.2908Z"
                    fill="white"
                />
            </g>
        </svg>
    );
};
